import { Button, Flex } from 'antd';
import { Icon } from 'components/shared/Atoms';
import LocalDropdown from 'components/ossix/LocalDropdown';
import { agbDropdownItems } from 'components/shared/HeaderContent/headerContentItem';
import 'components/shared/HeaderContent/index.scss';
import useLogout from 'hooks/useLogout';

const BKHeaderContent = ({
  profilePicture,
  lastName,
  firstName,
}: {
  profilePicture?: string | false;
  lastName?: string | false;
  firstName?: string | false;
}) => {
  const { contextHolder, onHandleLogout, loadLogoutUser } =
    useLogout();
  return (
    <Flex justify="flex-end" align="center" style={{ width: '100%' }}>
      {contextHolder}
      <Flex justify="center" align="center" gap="middle">
        <Button
          size="large"
          shape="circle"
          className="grey-color"
          icon={<Icon name="notification" />}
        />

        <LocalDropdown
          image={profilePicture}
          items={agbDropdownItems(loadLogoutUser, onHandleLogout)}
          firstName={firstName}
          lastName={lastName}
          isCircle
        />
      </Flex>
    </Flex>
  );
};

export default BKHeaderContent;
